<template>
  <div>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="filter.name" label="Имя клиента"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="filter.phoneNumber" label="Телефон"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="filter.email"  label="E-mail"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-select v-model="filter.status" :items="status" label="Статус" item-text="name" item-value="id">
            <template v-slot:item="{ item }">
              <v-chip
                style="color: white"
                class="ma-2"
                :color="item.color"
              >
                {{ item.name }}
              </v-chip>
            </template>
          </v-select>

        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-menu
            v-model="selectDateFrom"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filter.dateFrom"
                label="Дата с :"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filter.dateFrom" @input="selectDateFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-menu
            v-model="selectDateTo"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filter.dateTo"
                label="Дата по :"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filter.dateTo" @input="selectDateTo = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>

  export default {
    created() {
      axios.get('list-status')
        .then(({data}) => {
          this.status = data.data
        })
    },
    mounted() {
      var url = new URL(window.location.href);

      if(url.searchParams.get("name")){
        this.filter.name = url.searchParams.get("name")
      }

      if(url.searchParams.get("phoneNumber")){
        this.filter.phoneNumber = url.searchParams.get("phoneNumber")
      }

      if(url.searchParams.get("email")){
        this.filter.email = url.searchParams.get("email")
      }

      if(url.searchParams.get("dateFrom")){

        var timestamp = Date.parse((url.searchParams.get("dateFrom")));
        var dateObject = new Date(timestamp);

        this.filter.dateFrom = dateObject.toISOString().substr(0, 10);
      }

      if(url.searchParams.get("dateTo")){

        var timestamp = Date.parse((url.searchParams.get("dateTo")));
        var dateObject = new Date(timestamp);

        this.filter.dateTo = dateObject.toISOString().substr(0, 10);
      }




      this.loadReservation()
    },
    data() {
      return {
        status: [],
        items: ['foo', 'bar', 'fizz', 'buzz', 'fizzbuzz', 'foobar'],
        selectDateFrom: false,
        selectDateTo: false,
        filter: {
          name: '',
          phoneNumber: '',
          email: '',
          status: [],
          dateFrom: new Date().toISOString().substr(0, 10),
          dateTo: new Date().toISOString().substr(0, 10)
        }
      }
    },
    watch: {
      filter: {
        deep: true,
        handler() {
          this.debounced(this.loadReservation)
        }
      }
    },
    methods: {
      loadReservation(){
        this.$emit('changeFilter', Object.assign({}, this.filter));
      },
      debounced: _.debounce((cb) => {
        cb()
      }, 700),
    }
  }
</script>
